import React from "react"

const CancelArrow = (props) => {
  return (
    <button className="clock-in-panel__up" onClick={props.onClickCancel} title="Cancel">
      <img src="/images/clock-in/up.png"/>
    </button>
  )
}

export default CancelArrow
